import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetCountriesFromSapDealerQuery } from '../../api/endpoints/country';
import { useLanguage } from '../../contexts/LanguageContext';

const SapDealerCountryDropdown = ({ value, onChange, className, placeholder = 'Select a country', onBlur, disabled = false, languageId }) => {
    const { getCurrentLanguageId } = useLanguage();

    const selectedLanguageId = languageId || getCurrentLanguageId() || 1;

    const { data: countries = [], isLoading } = useGetCountriesFromSapDealerQuery({
        languageId: selectedLanguageId
    });

    const countryOptions = useMemo(() => {
        return countries.map((country) => {
            const code = country.countryCode || country.code;
            const name = country.countryName || country.name || code;

            return {
                id: code,
                code,
                name,
                text: name,
                displayValue: name
            };
        });
    }, [countries]);

    const selectedCountry = useMemo(() => {
        if (!value || countryOptions.length === 0) return null;

        if (typeof value === 'string') {
            return countryOptions.find((c) => c.id === value || c.code === value || c.name === value || c.text === value || c.displayValue === value) || null;
        }

        if (typeof value === 'object' && value !== null) {
            const searchId = value.id || value.code;
            const searchName = value.name || value.text || value.displayValue;

            return countryOptions.find((c) => (searchId && (c.id === searchId || c.code === searchId)) || (searchName && (c.name === searchName || c.text === searchName || c.displayValue === searchName))) || null;
        }

        return null;
    }, [value, countryOptions]);

    const handleChange = (e) => {
        if (onChange) {
            onChange(e.value);
        }
    };

    const countryOptionTemplate = (option) => {
        if (!option) return null;
        return (
            <div className="flex align-items-center">
                <span>{option.name}</span>
            </div>
        );
    };

    const selectedCountryTemplate = (option, props) => {
        if (option && option.name) {
            return (
                <div className="flex align-items-center">
                    <span>{option.name}</span>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    return (
        <Dropdown
            value={selectedCountry}
            onChange={handleChange}
            options={countryOptions}
            optionLabel="name"
            dataKey="id"
            className={className}
            placeholder={placeholder}
            onBlur={onBlur}
            disabled={disabled || isLoading}
            loading={isLoading}
            filter
            filterBy="name"
            showClear
            itemTemplate={countryOptionTemplate}
            valueTemplate={selectedCountryTemplate}
            emptyMessage="No countries found"
            emptyFilterMessage="No countries found"
            appendTo="self"
            panelClassName="country-dropdown-panel"
        />
    );
};

export default SapDealerCountryDropdown;
